import React, { Component } from 'react';
import 'react-infinite-calendar/styles.css'; // Make sure to import the default stylesheet

import Messagings from '../userPaygoInfoProfile/messaging/profile-user-global-messaging-menu.jsx';
import SuiviRecovery from './SuiviRecovery';
import ClientReports from './ClientReports';
import SwipeableTabs from '../../../commonModules/MUI/SwipeableTabs';
import TabsContent from '../../../commonModules/interface/TabsContent.jsx';


class SuiviGeneral extends React.PureComponent {
    state = {
        subHeaderMenu: "MAINTENANCE"
    }

    render() {
        // console.log("STATE POPUP",this.state);
        // console.log("PROPS", this.props);
        const { PAYMENTS, userInfo, paymentsIDList, recoveryIDList, getClientRecoveryActions, boxAssoId, abo} = this.props;
            
        return (
            <TabsContent
                labels={["Recouvrement", "Maintenance", "Messages"]}
            >
            
                <SuiviRecovery 
                    home
                    boxAssoId={boxAssoId}
                    // paygoID={paygoID}
                    abo={abo}
                    userInfo={userInfo} 
                    paymentsIDList={paymentsIDList} 
                    PAYMENTS={PAYMENTS}
                    recoveryIDList = {recoveryIDList}
                    getClientRecoveryActions = {getClientRecoveryActions}
                />
                <ClientReports boxAssoId={boxAssoId} />
                <Messagings boxAssoId={boxAssoId} />
                
            </TabsContent>

            // <div className="clearfix">                
            //     <div>                                                   
            //         <div>
            //             <ul className="tab-nav text-center fw-nav">
            //                 <li
            //                     className={this.state.subHeaderMenu === "RECOVERY" ? 'active waves-effect' : 'waves-effect'}
            //                     onClick={() => this.setState({ subHeaderMenu: "RECOVERY" })}
            //                 >
            //                     <a href="#actions">Recouvrement</a>
            //                 </li>
                            
            //                 <li
            //                     className={this.state.subHeaderMenu === "MAINTENANCE" ? 'active waves-effect' : 'waves-effect'}
            //                     onClick={() => this.setState({ subHeaderMenu: "MAINTENANCE" })}
            //                 >
            //                     <a href="#timeline">Maintenance</a>
            //                 </li>
            //                 <li
            //                     className={this.state.subHeaderMenu === "MESSAGE" ? 'active waves-effect' : 'waves-effect'}
            //                     onClick={() => this.setState({ subHeaderMenu: "MESSAGE" })}
            //                 >
            //                     <a href="#dashboard">Messages</a>
            //                 </li>
                            
            //             </ul>
            //             { this.state.subHeaderMenu === "MESSAGE" &&
            //                 <div>
            //                     <Messagings boxId={paygoID} />
            //                 </div>
            //             }
            //             { this.state.subHeaderMenu === "RECOVERY" &&
            //                 <SuiviRecovery 
            //                     home
            //                     userID={userID}
            //                     paygoID={paygoID}
            //                     userInfo={userInfo} 
            //                     paymentsIDList={paymentsIDList} 
            //                     PAYMENTS={PAYMENTS}
            //                     recoveryIDList = {recoveryIDList}
            //                     getClientRecoveryActions = {getClientRecoveryActions}
            //                 />
            //             }
            //             { this.state.subHeaderMenu === "MAINTENANCE" &&                       
            //                 <ClientReports paygoID={paygoID} />
            //             }
                        
            //         </div>
                    
            //     </div>
            // </div>
            
        );
    }
}

export default SuiviGeneral;
